(function () {

    var module = angular.module('app');

    module.factory('adminService', [
        "$http",
        function ($http) {
            var getAccounts = function () {
                return $http.get('/api/admin').then(function (response) { return response.data; });
            };

            return {
                getAccounts: getAccounts
            };
        }
    ]);
}());